/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.artifact.feature.tracing.rpc.ArtifactFeatureTracingRpc
 */

export const createFeatureTraceRpc = {
  serviceName: 'com.hubspot.artifact.feature.tracing.rpc.ArtifactFeatureTracingRpc',
  rpcName: 'createFeatureTrace',
  auth: 'app',
  fingerprint: 'UA-M4JQeNnlvEk3xud0X9K0oisKwkcUi',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createFeatureTraceWithArtifactIdRpc = {
  serviceName: 'com.hubspot.artifact.feature.tracing.rpc.ArtifactFeatureTracingRpc',
  rpcName: 'createFeatureTraceWithArtifactId',
  auth: 'app',
  fingerprint: 'mfGWOL5byi9vEk3xud0X9K0oisKwkcUi',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateArtifactIdRpc = {
  serviceName: 'com.hubspot.artifact.feature.tracing.rpc.ArtifactFeatureTracingRpc',
  rpcName: 'updateArtifactId',
  auth: 'app',
  fingerprint: 'eeUbOR5GngnkS261DjSIAa0oisKwkcUi',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateArtifactStateRpc = {
  serviceName: 'com.hubspot.artifact.feature.tracing.rpc.ArtifactFeatureTracingRpc',
  rpcName: 'updateArtifactState',
  auth: 'app',
  fingerprint: 'EDDe8AZsnrfkS261DjSIAa0oisKwkcUi',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateFeatureTraceRpc = {
  serviceName: 'com.hubspot.artifact.feature.tracing.rpc.ArtifactFeatureTracingRpc',
  rpcName: 'updateFeatureTrace',
  auth: 'app',
  fingerprint: 'dp2yjmhnH-LkS261DjSIAa0oisKwkcUi',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const stampFeatureRpc = {
  serviceName: 'com.hubspot.artifact.feature.tracing.rpc.ArtifactFeatureTracingRpc',
  rpcName: 'stampFeature',
  auth: 'app',
  fingerprint: '5f6zkxPqr3T9JmxT-dU0Ma0oisKwkcUi',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const stampFeatureByArtifactIdRpc = {
  serviceName: 'com.hubspot.artifact.feature.tracing.rpc.ArtifactFeatureTracingRpc',
  rpcName: 'stampFeatureByArtifactId',
  auth: 'app',
  fingerprint: 'iL9_kvbz3-_9JmxT-dU0Ma0oisKwkcUi',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};